module.exports = __webpack_public_path__ + "static/media/breastfed_img.54b5ce4e.png";